import { APIModelAttributes, APIEntityType } from '@ardoq/api-types';
import { fallbackComponentType, fallbackReferenceStyle } from './fallbackTypes';

export const fallbackModel: APIModelAttributes = Object.freeze({
  _id: 'fallback-model',
  name: 'fallback-model',
  description: '',
  category: 'Other',
  referenceTypes: Object.freeze({
    [fallbackReferenceStyle.id]: fallbackReferenceStyle,
  }),
  root: Object.freeze({ [fallbackComponentType.id]: fallbackComponentType }),
  flexible: false,
  useAsTemplate: false,
  blankTemplate: false,
  startView: null,
  defaultViews: [],
  created: '',
  createdBy: 'fallback',
  createdByEmail: 'fallback@ardoq.com',
  createdByName: 'Fallback',
  lastModifiedBy: 'fallback',
  lastModifiedByEmail: 'fallback@ardoq.com',
  lastModifiedByName: 'Fallback',
  lastUpdated: '',
  _version: 0,
  ardoq: {
    entityType: APIEntityType.MODEL,
  },
});
